import { IState } from './state';
import { IStore } from '../index';
import { ActionTree } from 'vuex';
import { validateTravelerAndRooms } from '@lib/inquiry/validateTravelerAndRooms';

export default {
    updateAndValidateTravelerNumber({ commit, state, getters }, travelerNumber) {
        const error = validateTravelerAndRooms(travelerNumber, state.doubleRoomAmount, state.singleRoomAmount, state.mixedRoomAmount, state.hasSharedDoubleRoom);
        state.selectedServices.forEach(([amount, service]) => {
            if (amount > travelerNumber) {
                commit('updateSelectedService', [travelerNumber, service.uid]);
            }
        });
        if (error && getters.getTravelerNumber > travelerNumber) {
            commit('setDoubleRoomAmount', 0);
            commit('setSingleRoomAmount', 0);
            commit('setMixedRoomAmount', 0);
        }
        commit('setError', error);
        commit('setTravelerNumber', travelerNumber);
        commit('setSharedDoubleRoomAmount', getters.getSharedDoubleRooms);
        commit('setCommonDoubleRoomAmount', getters.getCommonDoubleRooms);
    },
    updateAndValidateSingleRoomAmount({ commit, state, getters }, singleRoomAmount) {
        const error = validateTravelerAndRooms(state.travelerNumber, state.doubleRoomAmount, singleRoomAmount, state.mixedRoomAmount, state.hasSharedDoubleRoom);
        commit('setError', error);
        commit('setSingleRoomAmount', singleRoomAmount);
        commit('setSharedDoubleRoomAmount', getters.getSharedDoubleRooms);
        commit('setCommonDoubleRoomAmount', getters.getCommonDoubleRooms);
    },
    updateAndValidateMixedRoomAmount({ commit, state, getters }, mixedRoomAmount) {
        const error = validateTravelerAndRooms(state.travelerNumber, state.doubleRoomAmount, state.singleRoomAmount, mixedRoomAmount, state.hasSharedDoubleRoom);
        commit('setError', error);
        commit('setMixedRoomAmount', mixedRoomAmount);
        commit('setSharedDoubleRoomAmount', getters.getSharedDoubleRooms);
        commit('setCommonDoubleRoomAmount', getters.getCommonDoubleRooms);
    },
    updateAndValidateDoubleRoomAmount({ commit, state, getters }, doubleRoomAmount) {
        const error = validateTravelerAndRooms(state.travelerNumber, doubleRoomAmount, state.singleRoomAmount, state.mixedRoomAmount, state.hasSharedDoubleRoom);
        commit('setError', error);
        commit('setDoubleRoomAmount', doubleRoomAmount);
        commit('setSharedDoubleRoomAmount', getters.getSharedDoubleRooms);
        commit('setCommonDoubleRoomAmount', getters.getCommonDoubleRooms);
    }
} as ActionTree<IState, IStore>
